import React, { useState, useContext, useEffect, useRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { ApiService } from "../../../Component/services/apiServices";
import DataContext from "../../../Component/context";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";
import { Badge } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
function CateringBookingModal() {
    const contextValues = useContext(DataContext);
    const isOrderStop = contextValues?.settingData?.order_stop == 1 || contextValues?.settingData?.order_stop === true;
    const navigate = useNavigate()
    const [currentStep, setCurrentStep] = useState(1);
    const [deliveryAmount, setDeliveryAmount] = useState(0);
    const [contactInputs, setcontactInputs] = useState({
        contact_id: 0,
        contact_name: "",
        contact_email: "",
        contact_mobile: "",
        contact_event_date: "",
        contact_call_time: "",
        contact_type: 1,
        contact_subject: "",
        contact_message: "",
        contact_occasion: "",
        contact_people: "",
        contact_booking_type: "delivery",
        contact_store_location: 0,
        contact_delivery_address: "",
        contact_add_note: "",
    });

    const [cartSummary, setCartSummary] = useState({
        itemTotal: 0,
        discount: 0,
        total_amount: 0,
        addon_amount: 0,
        sellingTotal: 0,
        delivery_amount: 0
    });
    const [contactAuthId, setContactAuthId] = useState(null);
    const categoryRefs = useRef({});
    const [buttonLoader, setButtonLoader] = useState(false);
    const [Loader, setLoader] = useState(false);
    const [errors, setErrors] = useState({});
    const timeZone = "Australia/Sydney";
    const [productDetail, setProductDetail] = useState({})
    const [productWeekDay, setProductWeekDay] = useState({})
    const [TiffinItem, SetTiffinItem] = useState([])
    const [isInnerLoading, setIsInnerLoading] = useState(false)
    const [isLoading, setisLoading] = useState(false)
    const [validationErrors, setValidationErrors] = useState([]);
    const [isMOQMet, setIsMOQMet] = useState({});
    const [activeDay, setActiveDay] = useState(moment().tz(timeZone).format('dddd'));
    const [daysOfWeek, setDaysOfWeek] = useState(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']);
    const [currentActiveDate, setCurrentActiveDate] = useState('');
    const [paymentMode, setPaymentMode] = useState('card');
    const [cateringBookingStores, setCateringBookingStores] = useState([]);

    const cateringModal = () => {
        if (contextValues.toggleCateringModal) {
            setCurrentStep(1);
            setButtonLoader(false); setLoader(false);
            setContactAuthId(null);
            setcontactInputs({
                contact_id: 0,
                contact_name: "",
                contact_email: "",
                contact_mobile: "",
                contact_event_date: "",
                contact_call_time: "",
                contact_type: 1,
                contact_subject: "",
                contact_message: "",
                contact_occasion: "",
                contact_people: "",
                contact_booking_type: "delivery",
                contact_store_location: 0,
            });
        }
        contextValues.setToggleCateringModal(!contextValues.toggleCateringModal);
    };

    const fetchUserDetails = () => {
        const existingUserSession = localStorage.getItem("CATERING_USER_DETAILS");
        if (existingUserSession) {
            const userDetails = JSON.parse(existingUserSession);
            setcontactInputs({
                contact_id: userDetails.contact_id || 0,
                contact_name: userDetails.contact_name || "",
                contact_email: userDetails.contact_email || "",
                contact_mobile: userDetails.contact_mobile || "",
                contact_people: userDetails.contact_people || "",
                contact_occasion: userDetails.contact_occasion || "",
                contact_booking_type: userDetails.contact_booking_type || "delivery",
                contact_store_location: userDetails.contact_store_location || 0,
            });

            return;
        }

        ApiService.fetchData("profile-data")
            .then((res) => {
                if (res?.status === "success") {
                    setcontactInputs({
                        contact_name: res?.userData?.user_name || "",
                        contact_email: res?.userData?.user_email || "",
                        contact_mobile: res?.userData?.user_mobile || "",
                        contact_people: "",
                        contact_occasion: "",
                        contact_booking_type: "delivery",
                        contact_store_location: 0,
                    });
                }
            })
            .catch(() => { });
    };

    const fetchStoreLocations = () => {
        ApiService.fetchData("getourstoredata")
            .then((res) => {
                if (res?.status === "success") {
                    setcontactInputs(prev => ({ ...prev, ['contact_store_location']: res?.resStoreData[0]?.store_id || 0 }));
                    setCateringBookingStores(res?.resStoreData || []);
                }
            })
            .catch(() => { });
    };

    /************************************* Step 1 *************************************/

    const handleContactInput = (e) => {
        const { name, value } = e.target;
        setcontactInputs(prev => ({ ...prev, [name]: value, }));
    };

    const validateNoticePeriod = () => {
        if (
            productDetail?.product_notice === "" ||
            productDetail?.product_notice == null
        ) {
            return true;
        }

        const now = moment();
        const eventDate = moment(
            contextValues.selectedCateringMenu?.activeDay
        ).startOf("day");

        let requiredDateTime = now.clone();
        let noticeLabel = "";

        switch (String(productDetail.product_notice)) {
            case "0":
                requiredDateTime.add(20, "minutes");
                noticeLabel = "20 Minutes";
                break;

            case "1":
                requiredDateTime.add(5, "hours");
                noticeLabel = "5 Hours";
                break;

            case "2":
                requiredDateTime.add(8, "hours");
                noticeLabel = "8 Hours";
                break;

            case "3":
                requiredDateTime.add(10, "hours");
                noticeLabel = "10 Hours";
                break;

            case "4":
                requiredDateTime.add(1, "day");
                noticeLabel = "1 Day";
                break;

            case "5":
                requiredDateTime.add(2, "days");
                noticeLabel = "2 Days";
                break;

            case "6":
                requiredDateTime.add(1, "week");
                noticeLabel = "1 Week";
                break;

            default:
                return true;
        }

        // Selected event date must be after required notice period
        if (eventDate.isBefore(requiredDateTime.startOf("day"))) {
            toast.error(
                `This catering requires at least ${noticeLabel} notice.`
            );
            return false;
        }

        return true;
    };

    const ContactformHandleStep1 = () => {
        const {
            contact_name = "",
            contact_email = "",
            contact_mobile = "",
            contact_people = "",
            contact_occasion = "",
            contact_event_date = "",
            contact_booking_type = "delivery",
            contact_store_location = 0,
        } = contactInputs || {};

        if (!contact_name.trim()) {
            toast.error("Please enter your name.");
            return;
        }

        if (!contact_email.trim()) {
            toast.error("Please enter your email address.");
            return;
        }

        const validEmail =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!validEmail.test(contact_email)) {
            toast.error("Please enter a valid email address.");
            return;
        }

        const mobile = contact_mobile.replace(/\s+/g, "");

        if (!/^[0-9]{10,15}$/.test(mobile)) {
            toast.error("Please enter a valid mobile number.");
            return;
        }

        if (!contact_people) {
            toast.error("Please enter no. of guests.");
            return;
        }

        if (!String(contact_occasion).trim()) {
            toast.error("Please choose Occasion type.");
            return;
        }

        if (productDetail.product_min_people > 0) {
            if (Number(contact_people) < Number(productDetail.product_min_people)) {
                toast.error(
                    "This catering package requires a minimum of " +
                    productDetail.product_min_people +
                    " people"
                );
                return false;
            }
        }

        if (productDetail.product_max_people > 0) {
            if (Number(contact_people) > Number(productDetail.product_max_people)) {
                toast.error(
                    "This catering package is available for a maximum of " +
                    productDetail.product_max_people +
                    " people"
                );
                return false;
            }
        }

        if (!validateNoticePeriod()) {
            return;
        }
        setButtonLoader(true);
        setLoader(true);

        const dataToSend = {
            contact_name: contactInputs.contact_name,
            contact_email: contactInputs.contact_email,
            contact_mobile: contactInputs.contact_mobile,
            contact_type: productDetail?.product_type,
            contact_people: contactInputs.contact_people,
            contact_occasion: contactInputs.contact_occasion,
            contact_event_date: moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('YYYY-MM-DD'),
        };

        ApiService.postData("cateringBookingStep1", dataToSend).then(
            (res) => {
                if (res?.status === "success") {
                    if (productDetail?.product_type === 0) {
                        toast.success("Details saved! Proceeding to the next step...");
                        setCurrentStep(prev => prev + 1);
                    } else {
                        setCurrentStep(6);
                    }
                    localStorage.setItem("CATERING_USER_DETAILS", JSON.stringify(res.userDetails));
                    setcontactInputs({
                        contact_id: res.userDetails.contact_id || 0,
                        contact_name: res.userDetails.contact_name || "",
                        contact_email: res.userDetails.contact_email || "",
                        contact_mobile: res.userDetails.contact_mobile || "",
                        contact_people: res.userDetails.contact_people || "",
                        contact_occasion: res.userDetails.contact_occasion || "",
                        contact_event_date: moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('YYYY-MM-DD'),
                        contact_booking_type: "delivery",
                        contact_store_location: 0,
                    });
                    setButtonLoader(false);
                    setLoader(false);
                } else if (res?.status === "error") {
                    setButtonLoader(false);
                    setLoader(false);
                    toast.error(res.message || "An error occurred while saving Step 1.");
                }
            }
        ).catch(() => {
            setButtonLoader(false);
            setLoader(false);
            toast.error("An unexpected error occurred during lead capture.");
        });
    };

    /************************************* Step 2 *************************************/

    useEffect(() => {
        if (contextValues.toggleCateringModal && contextValues.selectedCateringMenu) {
            fetchUserDetails();
            fetchStoreLocations();
            getProductDetail();
        }
    }, [contextValues.toggleCateringModal, contextValues.selectedCateringMenu]);

    const getProductDetail = () => {
        setisLoading(true)
        const dataString = {
            product_id: contextValues.selectedCateringMenu?.product_slug,
            active_day: moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('dddd')
        }
        ApiService.postData('cateringMenuDetails', dataString).then((res) => {
            if (res.status === 'success') {
                setProductWeekDay(res?.productWeekDay)
                setProductDetail(res?.menuData)
                SetTiffinItem(res?.tiffinItem)
                setDeliveryAmount(res?.adminData?.catering_delivery_amount || 0)
                let nextDays = [];
                nextDays = getNextDays(activeDay, 7).map(day =>
                    moment(day).tz(timeZone).format("YYYY-MM-DD")
                );
                setCurrentActiveDate(nextDays[0]);
                setTimeout(() => {
                    setisLoading(false)
                }, 500);
            } else {
                setisLoading(false)
            }
        }).catch(() => { setisLoading(false) })
    }

    function getNextDays(productSelectedDay, count = 5) {
        const dayToFind = daysOfWeek.indexOf(productSelectedDay);

        if (dayToFind === -1) {
            throw new Error(`Invalid day: ${productSelectedDay}. Please provide a valid day (e.g., 'Monday', 'Tuesday').`);
        }

        const result = [];
        let currentDate = moment().tz(timeZone);

        while (currentDate.day() !== dayToFind) {
            currentDate.add(1, "day");
        }

        for (let i = 0; i < count; i++) {
            result.push(currentDate.format("YYYY-MM-DD"));
            currentDate.add(7, "days");
        }

        return result;
    }

    const handleItemToggle = (selitem, categoryItem) => {
        SetTiffinItem((prev) =>
            prev.map((category) => {
                if (
                    category.tiffin_category.cat_id !==
                    categoryItem.tiffin_category.cat_id
                ) {
                    return category;
                }

                const isAddonCategory =
                    categoryItem?.tiffin_category?.addon_category === 1;

                const selectedCount = category.menu_items.filter(
                    (item) => item.checked
                ).length;

                const updatedMenuItems = category.menu_items.map((item) => {
                    if (item.product_id !== selitem.product_id) {
                        return item;
                    }

                    // Uncheck selected item
                    if (item.checked) {
                        return { ...item, checked: false };
                    }

                    // Addon category → unlimited selection
                    if (isAddonCategory) {
                        return { ...item, checked: true };
                    }

                    // Normal category → apply MOQ limit
                    if (selectedCount < categoryItem.pti_moq) {
                        return { ...item, checked: true };
                    }

                    return item;
                });

                const totalSelected = updatedMenuItems.filter(
                    (item) => item.checked
                ).length;

                setIsMOQMet((prevState) => ({
                    ...prevState,
                    [categoryItem.tiffin_category.cat_id]: isAddonCategory
                        ? true
                        : totalSelected >= categoryItem.pti_moq,
                }));

                return {
                    ...category,
                    menu_items: updatedMenuItems,
                };
            })
        );
    };

    const handleQuantityChangeExtras = (itemchild, item, increment) => {
        setValidationErrors([]);
        SetTiffinItem((prevTiffinItems) => {
            return prevTiffinItems.map((category) => {
                if (category.tiffin_category.cat_id === item.tiffin_category.cat_id) {
                    const updatedMenuItems = category.menu_items.map((menuItem) => {
                        if (menuItem.product_id === itemchild.product_id) {
                            const currentQty = menuItem.qty || 0;
                            const newQty = increment ? currentQty + 1 : currentQty - 1;
                            return { ...menuItem, qty: Math.max(newQty, 0) };
                        }
                        return menuItem;
                    });
                    const totalSelectedQty = updatedMenuItems.reduce(
                        (total, menuItem) => total + (menuItem.qty || 0),
                        0
                    );
                    setIsMOQMet((prev) => {
                        const updatedMOQState = { ...prev };
                        if (totalSelectedQty >= item.pti_moq) {
                            updatedMOQState[category.tiffin_category.cat_id] = true;
                        } else {
                            delete updatedMOQState[category.tiffin_category.cat_id];
                        }
                        return updatedMOQState;
                    });
                    return { ...category, menu_items: updatedMenuItems };
                }
                return category;
            });
        });
    };

    const ContactformHandleStep2 = () => {
        for (const category of TiffinItem) {
            const selectedCount = category.menu_items.filter(
                (item) => item.checked
            ).length;

            const requiredCount = Number(category.pti_moq || 0);

            if (requiredCount > 0 && selectedCount < requiredCount) {
                toast.error(`Please choose ${requiredCount} item(s) from ${category.tiffin_category.cat_name}`);
                return;
            }
        }

        const addon_amount = TiffinItem.reduce(
            (totalAddon, category) => {
                if (Number(category?.tiffin_category?.addon_category) !== 0) {
                    const categoryTotal = (category?.menu_items || []).reduce(
                        (menuTotal, item) => {
                            return item.qty > 0 ? menuTotal + ((Number(item.product_price) || 0) * (Number(item.qty) || 1)) : menuTotal;
                        },
                        0
                    );

                    return totalAddon + categoryTotal;
                }

                return totalAddon;
            },
            0
        );

        let updatedCart = [
            {
                product_id: productDetail.product_id,
                product_uniqueid: productDetail.product_uniqueid,
                product_name: productDetail.product_name,
                product_image: productDetail.product_image,
                product_price: productDetail.product_price,
                product_selling_price: productDetail.product_selling_price,
                product_discount: productDetail.product_discount,
                product_tiffin_items: TiffinItem,
                product_slug: productDetail?.product_slug,
                addon_amount: Number(addon_amount).toFixed(2)
            },
        ];



        setButtonLoader(true);
        setLoader(true);

        const postString = {
            updatedCart: updatedCart,
            auth: contactInputs.contact_id
        };

        ApiService.postData("cateringBookingStep2", postString).then(
            (res) => {
                if (res?.status === "success") {
                    toast.success("Menu saved. Proceeding to the next step...");
                    setCurrentStep(prev => prev + 1);
                    setButtonLoader(false);
                    setLoader(false);
                } else if (res?.status === "error") {
                    setButtonLoader(false);
                    setLoader(false);
                    toast.error(res.message || "An error occurred while saving Step 1.");
                }
            }
        ).catch(() => {
            setButtonLoader(false);
            setLoader(false);
            toast.error("An unexpected error occurred during lead capture.");
        });
    };

    /************************************* Step 3 *************************************/

    useEffect(() => {
        const parsedCartSummary = {
            itemTotal: 0,
            discount: 0,
            total_amount: 0,
            addon_amount: 0,
            sellingTotal: 0,
            delivery_amount: 0
        };

        parsedCartSummary.itemTotal = (Number(productDetail?.product_price) || 0) * (Number(contactInputs.contact_people) || 0);

        parsedCartSummary.sellingTotal = (Number(productDetail?.product_selling_price) || 0) * (Number(contactInputs.contact_people) || 0);

        parsedCartSummary.discount = ((Number(productDetail?.product_price) || 0) - (Number(productDetail?.product_selling_price) || 0)) * (Number(contactInputs.contact_people) || 0);

        parsedCartSummary.addon_amount = TiffinItem.reduce(
            (totalAddon, category) => {
                if (Number(category?.tiffin_category?.addon_category) !== 0) {
                    const categoryTotal = (category?.menu_items || []).reduce(
                        (menuTotal, item) => {
                            return item.qty > 0 ? menuTotal + ((Number(item.product_price) || 0) * (Number(item.qty) || 1)) : menuTotal;
                        },
                        0
                    );

                    return totalAddon + categoryTotal;
                }

                return totalAddon;
            },
            0
        );
        parsedCartSummary.delivery_amount = contactInputs.contact_booking_type === "delivery" ? Number(deliveryAmount) : 0;

        parsedCartSummary.total_amount = parsedCartSummary.sellingTotal + parsedCartSummary.addon_amount + parsedCartSummary.delivery_amount;

        setCartSummary(parsedCartSummary);
    }, [currentStep, contactInputs, deliveryAmount]);

    const ContactformHandleStep3 = async () => {
        setCurrentStep(prev => prev + 1)
    }

    /************************************* Step 4 *************************************/

    const [newCardState, setNewCardState] = useState({
        ucd_id: 0,
        number: "",
        name: "",
        expiry: "",
        cvc: "",
        focus: "",
        save_card: 0
    });

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        let updatedValue = type === 'checkbox' ? (checked ? 1 : 0) : value;
        if (name === 'number') {
            const numberWithoutSpaces = value.replace(/\s/g, '');
            updatedValue = numberWithoutSpaces.replace(/\D/g, '');
            updatedValue = updatedValue.replace(/[^\d]/g, '');
            updatedValue = updatedValue.replace(/(.{4})/g, '$1 ').trim();
            if (updatedValue.length > 20) {
                return false;
            }
        } else if (name === 'expiry') {
            updatedValue = value.replace(/[^\d\/]/g, '');
            if (updatedValue.length === 2 && !updatedValue.includes('/')) {
                updatedValue += '/';
            }
            if (updatedValue.length > 5) {
                return false;
            }
        } else if (name === 'cvc') {
            const numberWithoutSpaces = value.replace(/\s/g, '');
            updatedValue = numberWithoutSpaces.replace(/\D/g, '');
            updatedValue = updatedValue.replace(/[^\d]/g, '');
            updatedValue = updatedValue.replace(/(.{4})/g, '$1 ').trim();
            if (updatedValue.length > 4) {
                return false;
            }
        }
        setNewCardState({
            ...newCardState,
            [name]: updatedValue
        });
    };

    const selectPayMethod = (mode) => {
        setPaymentMode(mode)
    }

    const ContactformHandleStep4 = async () => {
        setLoader(true)
        try {

            if (contactInputs.contact_booking_type === "pickup") {

                if (!contactInputs.contact_call_time?.trim()) {
                    toast.error("Please enter pickup time.");
                    return;
                }

                if (
                    !contactInputs.contact_store_location ||
                    contactInputs.contact_store_location === "0" ||
                    Number(contactInputs.contact_store_location) === 0
                ) {
                    toast.error("Please choose a store location.");
                    return;
                }
            }

            if (contactInputs.contact_booking_type === "delivery") {

                if (!contactInputs.contact_call_time) {
                    toast.error("Please select a delivery time.");
                    return;
                }

                if (!contactInputs.contact_delivery_address?.trim()) {
                    toast.error("Please enter the delivery address.");
                    return;
                }
            } 

            if (newCardState.number === '') {
                toast.error('Please enter card number')
                return false;
            } else if (newCardState.number.length > 19 || newCardState.number.length < 19) {
                toast.error('Please enter valid card details')
                return false;
            }

            if (newCardState.expiry === '') {
                toast.error('Please enter Expiry ')
                return false;
            }

            const currentDate = new Date();
            const currentYear = currentDate.getFullYear() % 100;
            const currentMonth = currentDate.getMonth() + 1;
            const [inputMonth, inputYear] = newCardState.expiry.split('/').map(Number);
            const isValidDate = inputYear > currentYear || (inputYear === currentYear && inputMonth <= currentMonth);
            if (!isValidDate) {
                toast.error('Please enter valid expiry')
                return false;
            }

            if (newCardState.cvc.length !== 3) {
                toast.error('Please enter valid CVV')
                return false;
            }

            const postString = {
                itemTotal: cartSummary?.itemTotal,
                discount: cartSummary?.discount,
                addon_amount: cartSummary?.addon_amount,
                total_amount: cartSummary?.total_amount,
                delivery_amount: cartSummary?.delivery_amount,
                auth: contactInputs.contact_id,

                contact_booking_type: contactInputs.contact_booking_type,
                contact_store_location: contactInputs.contact_store_location,
                contact_delivery_address: contactInputs.contact_delivery_address,
                contact_add_note: contactInputs.contact_add_note,
                contact_call_time: contactInputs.contact_call_time,

                card_number: Number(newCardState.number.replace(/\s/g, '')),
                exp_month: inputMonth,
                exp_year: inputYear,
                cvc: newCardState.cvc,
                name: newCardState.name,
            };

            const res = await ApiService.postData("cateringBookingStep4", postString);
            if (res.status === "success") {
                setCurrentStep(prev => prev + 1)
            } else {
                toast.error(res?.message || "An unexpected error occurred during lead capture.");
            }
        } catch (error) {
            console.error(error);
            toast.error("An unexpected error occurred during lead capture.");
        } finally {
            setLoader(false);
        }
    }

    return (
        <>
            <Modal className='ca_Modal' show={contextValues.toggleCateringModal} onHide={cateringModal}>
                <div className="modal-progress">
                    <div
                        className="modal-progress-fill"
                        style={{ width: `${(currentStep / 4) * 100}%` }}
                    ></div>
                </div>
                <div className="modal-header">
                    <div className="modal-header-left">
                        <div className="modal-icon"><i className="ri-bowl-line"></i></div>
                        <div style={{ lineHeight: '16px' }}>
                            <div className="modal-title">
                                {currentStep === 1 && " Book Catering"}
                                {currentStep === 2 && " Book Catering"}
                                {currentStep === 3 && " Book Summary"}
                                {currentStep === 4 && " Payment"}
                                {currentStep === 5 && " Thank You"}
                                {currentStep === 6 && " Thank You"}
                            </div>
                            <div className="modal-step-badge">
                                {
                                    productDetail?.product_type === 0
                                        ? `${currentStep} of 5`
                                        : currentStep === 1
                                            ? '1 of 2'
                                            : '2 of 2'
                                } —
                                {currentStep === 1 && " Contact Info"}
                                {currentStep === 2 && " Choose Menu"}
                                {currentStep === 3 && " Summary"}
                                {currentStep === 4 && " Payment"}
                                {currentStep === 5 && " Thank You"}
                                {currentStep === 6 && " Thank You"}
                            </div>
                        </div>
                    </div>
                    <button className="modal-closee" onClick={cateringModal} aria-label="Close">✕</button>
                </div>
                {currentStep == 1 &&
                    <>
                        <div className="modal-body">
                            <div className="modal-step active">
                                <p className="modal-intro">Here's what you've selected. Continue to choose your menu.</p>
                                <div className="s1-recap-card">
                                    <div className="s1-recap-row">
                                        <div className="s1-recap-item">
                                            <div className="s1-recap-label">Package</div>
                                            <div className="s1-recap-value">{productDetail.product_name}</div>
                                        </div>
                                        <div className="s1-recap-divider"></div>
                                        <div className="s1-recap-item">
                                            <div className="s1-recap-label">Event Date</div>
                                            <DatePicker
                                                selected={
                                                    contextValues.selectedCateringMenu?.activeDay
                                                        ? new Date(contextValues.selectedCateringMenu?.activeDay)
                                                        : new Date()
                                                }
                                                minDate={new Date()}
                                                dateFormat="dd/MM/yyyy"
                                                onChange={(date) => {
                                                    const formattedDate = moment(date).format("YYYY-MM-DD");

                                                    contextValues.setSelectedCateringMenu((prev) => ({
                                                        ...prev,
                                                        ['activeDay']: formattedDate,
                                                    }));
                                                }}
                                                customInput={<div className="s1-recap-value">{moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('dddd, DD MMM YYYY')}</div>}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="s1-info-strip">
                                    <span>✅ Package &amp; date locked in</span>
                                    <span>·</span>
                                    <span>Next: pick your dishes</span>
                                </div>
                                <div className="step1-divider"><span>Your Contact Details</span></div>
                                <div className="row g-3">
                                    <div className="col-lg-12">
                                        <div className="field">
                                            <label>Your Name</label>
                                            <input type="text" placeholder="e.g. Priya Sharma" name="contact_name" value={contactInputs.contact_name} onChange={handleContactInput} />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="field">
                                            <label>Email Address</label>
                                            <input type="email" name="contact_email" placeholder="you@example.com" value={contactInputs.contact_email} onChange={handleContactInput}></input>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="field">
                                            <label>Mobile Number</label>
                                            <input
                                                type="text"
                                                name="contact_mobile"
                                                placeholder="04XX XXX XXX"
                                                value={contactInputs.contact_mobile}
                                                onChange={(e) => {
                                                    const value = e.target.value.replace(/[^0-9]/g, "");
                                                    setcontactInputs({
                                                        ...contactInputs,
                                                        contact_mobile: value,
                                                    });
                                                }}
                                                maxLength={15}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="field">
                                            <label>No. of Guests </label>
                                            <input
                                                type="number"
                                                min="1"
                                                placeholder="1"
                                                name="contact_people"
                                                value={contactInputs.contact_people}
                                                onChange={handleContactInput}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="field">
                                            <label>Occasion Type </label>
                                            <select
                                                name="contact_occasion"
                                                value={contactInputs.contact_occasion}
                                                onChange={handleContactInput}
                                            >
                                                <option value="">Choose...</option>
                                                <option value="Shadi ka Ghar">Shadi ka Ghar</option>
                                                <option value="Bachelor Party">Bachelor Party</option>
                                                <option value="Hen's Night">Hen's Night</option>
                                                <option value="Roka">Roka</option>
                                                <option value="Engagement">Engagement</option>
                                                <option value="Haldi">Haldi</option>
                                                <option value="Mehendi">Mehendi</option>
                                                <option value="Wedding">Wedding</option>
                                                <option value="Reception">Reception</option>
                                                <option value="Corporate Event">Corporate Event</option>
                                                <option value="Weekend Chill">Weekend Chill</option>
                                                <option value="Birthday Party">Birthday Party</option>
                                                <option value="House Party">House Party</option>
                                                <option value="Inviting Guests">Inviting Guests</option>
                                                <option value="Pooja Ceremony">Pooja Ceremony</option>
                                                <option value="Anniversary">Anniversary</option>
                                                <option value="Baby Shower">Baby Shower</option>
                                                <option value="House Warming">House Warming</option>
                                                <option value="Kitty Party">Kitty Party</option>
                                                <option value="High Tea">High Tea</option>
                                                <option value="Other Occasion">Other Occasion</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="modal-next" onClick={() => ContactformHandleStep1()} disabled={Loader}>{Loader ? (<img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" />) : "Continue → "}</button>
                        </div>
                    </>
                }
                {currentStep == 2 &&
                    <>
                        <div className="modal-body">
                            <div className="modal-step active">
                                <p className="modal-intro">Tap the dishes you'd like included in your catering.</p>
                                <div className="step2-pkg-recap">
                                    <span className="step2-pkg-recap-icon">🥘</span>
                                    <div className="step2-pkg-recap-info">
                                        <div className="step2-pkg-recap-label">Package · —</div>
                                        <div className="step2-pkg-recap-name">{productDetail?.product_name}</div>
                                    </div>
                                    <div style={{ lineHeight: '16px', textAlign: 'right' }}>
                                        <div className="step2-pkg-recap-label">Date</div>
                                        <div className="step2-pkg-recap-name">{moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('dddd, DD MMM YYYY')}</div>
                                    </div>
                                </div>
                                <div className="menu-chooser">
                                    <div className="menu-chooser-header">
                                        <div className="menu-chooser-title">
                                            <span>🥘</span>
                                            <span>Budget Large · Scaled Daily Menu</span>
                                        </div>
                                    </div>
                                    <div>
                                        {TiffinItem?.length > 0 &&
                                            TiffinItem.map((items, categoryIndex) => {
                                                return (
                                                    items?.tiffin_category?.addon_category === 0 &&
                                                    <div key={categoryIndex}>
                                                        <div className="menu-cat-label">
                                                            {items?.tiffin_category?.cat_name} {items.pti_moq > 0 && (<span className="mb-0" style={{ color: "#f5a94e" }}> (Choose {items.pti_moq})</span>)}
                                                        </div>

                                                        {items?.menu_items?.map((itemsChild, indexchild) => {
                                                            const selectedCount = items.menu_items.filter(
                                                                (item) => item.checked
                                                            ).length;

                                                            const isLimitReached =
                                                                items?.tiffin_category?.addon_category === 0 &&
                                                                selectedCount >= items.pti_moq;

                                                            const isDisabled =
                                                                isLimitReached && !itemsChild.checked;
                                                            return (
                                                                items.pti_moq > 0 ?
                                                                    <div
                                                                        data={items.pti_moq}
                                                                        key={indexchild}
                                                                        className={`menu-dish-row ${itemsChild?.checked || Number(items.pti_moq) === 0 ? "chosen" : ""} ${isDisabled ? "menu-dish-row-disable" : ""}`}
                                                                        onClick={() => handleItemToggle(itemsChild, items)}
                                                                    >
                                                                        <div className="menu-dish-info">
                                                                            <div className="menu-dish-name">
                                                                                {itemsChild?.product_name}
                                                                            </div>
                                                                            <div className="menu-dish-desc">
                                                                                {itemsChild?.product_measure &&
                                                                                    itemsChild?.product_measure !== "Select Measure" &&
                                                                                    itemsChild?.product_unit_of_measure && (
                                                                                        <span>
                                                                                            {" "}
                                                                                            QTY: {itemsChild.product_measure}{" "}
                                                                                            {itemsChild.product_unit_of_measure} x{" "}
                                                                                            {contactInputs.contact_people} {"Guests"} ={" "}
                                                                                            {Number(itemsChild.product_measure) *
                                                                                                Number(contactInputs.contact_people)}{" "}
                                                                                            {itemsChild.product_unit_of_measure}
                                                                                        </span>
                                                                                    )}
                                                                            </div>
                                                                            {itemsChild?.product_description && (
                                                                                <div className="menu-dish-desc">
                                                                                    {itemsChild?.product_description}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="menu-dish-checkbox" >
                                                                            {itemsChild?.checked || Number(items.pti_moq) === 0 ? "✓" : ""}
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div
                                                                        data={items.pti_moq}
                                                                        key={indexchild}
                                                                        className={`menu-dish-row ${itemsChild?.checked || Number(items.pti_moq) === 0 ? "chosen" : ""}`}
                                                                    >
                                                                        <div className="menu-dish-info">
                                                                            <div className="menu-dish-name">
                                                                                {itemsChild?.product_name}
                                                                            </div>
                                                                            <div className="menu-dish-desc">
                                                                                {itemsChild?.product_measure &&
                                                                                    itemsChild?.product_measure !== "Select Measure" &&
                                                                                    itemsChild?.product_unit_of_measure && (
                                                                                        <span>
                                                                                            {" "}
                                                                                            QTY: {itemsChild.product_measure}{" "}
                                                                                            {itemsChild.product_unit_of_measure} x{" "}
                                                                                            {contactInputs.contact_people} {"Guests"} ={" "}
                                                                                            {Number(itemsChild.product_measure) *
                                                                                                Number(contactInputs.contact_people)}{" "}
                                                                                            {itemsChild.product_unit_of_measure}
                                                                                        </span>
                                                                                    )}
                                                                            </div>
                                                                            {itemsChild?.product_description && (
                                                                                <div className="menu-dish-desc">
                                                                                    {itemsChild?.product_description}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <div className="menu-dish-checkbox" >
                                                                            {itemsChild?.checked || Number(items.pti_moq) === 0 ? "✓" : ""}
                                                                        </div>
                                                                    </div>
                                                            )
                                                        })}
                                                    </div>
                                                )
                                            })}
                                    </div>
                                    <div className="menu-chooser-note">⏱ 8 hours notice lets us scale up from our daily kitchen — freshest food at the best price.</div>
                                </div>

                                {TiffinItem?.length > 0 &&
                                    TiffinItem.map((items, categoryIndex) => {
                                        return (
                                            items?.tiffin_category?.addon_category !== 0 && items?.menu_items?.length > 0 &&
                                            <div className="addon-section" key={categoryIndex}>
                                                <div className="addon-section-header">
                                                    <span>✨ {items?.tiffin_category?.cat_name}</span>
                                                    <span className="addon-section-sub">Optional extras for your event</span>
                                                </div>
                                                <div className="addon-list">
                                                    {items?.menu_items?.map((itemsChild, indexchild) => (
                                                        <div className={`addon-row ${itemsChild?.qty && itemsChild?.qty > 0 && 'has-qty'}`}>
                                                            <div className="addon-info">
                                                                <div className="addon-name">{itemsChild?.product_name}</div>
                                                                {itemsChild?.product_description && (<div className="addon-desc">{itemsChild?.product_description}</div>)}
                                                                <div className="addon-desc">
                                                                    {itemsChild?.product_measure &&
                                                                        itemsChild?.product_measure !== "Select Measure" &&
                                                                        itemsChild?.product_unit_of_measure && (
                                                                            <span>
                                                                                QTY: {itemsChild.product_measure} {itemsChild.product_unit_of_measure}{" "}
                                                                                {Number(itemsChild?.qty) > 0 &&
                                                                                    <>
                                                                                        x{" "}
                                                                                        {itemsChild?.qty} ={" "}
                                                                                        {Number(itemsChild.product_measure) *
                                                                                            Number(itemsChild?.qty)}{" "}
                                                                                        {itemsChild.product_unit_of_measure}
                                                                                    </>
                                                                                }

                                                                            </span>
                                                                        )}
                                                                </div>
                                                            </div>
                                                            <span className="addon-price">${itemsChild?.product_price}</span>
                                                            <div className="addon-qty">
                                                                <button className="addon-btn" onClick={() => handleQuantityChangeExtras(itemsChild, items, false)}><i className="ri-subtract-line"></i></button>
                                                                <span className="addon-qty-num">{itemsChild?.qty || 0}</span>
                                                                <button className="addon-btn" onClick={() => handleQuantityChangeExtras(itemsChild, items, true)}><i className="ri-add-line"></i></button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )
                                    })}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div>
                                <div className="alert alert-warning tx-14" style={{ lineHeight: "16px", marginBottom: "1rem", textAlign: "center", padding: "6px" }}>Paneer dishes are always a guest favorite. Consider adding an extra paneer dish to ensure everyone is happy.</div>
                                <div className="d-flex" style={{ gap: '.75rem' }}>
                                    <button className="modal-back" aria-label="Go back" onClick={() => setCurrentStep(prev => prev - 1)}><i className="ri-arrow-left-line"></i></button>
                                    <button className="modal-next" onClick={() => ContactformHandleStep2()} disabled={Loader}>{Loader ? (<img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" />) : "Continue → "}</button>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {currentStep == 3 &&
                    <>
                        <div className="modal-body">
                            <div className="modal-step active">
                                <p className="modal-intro">Review your full booking before submitting.</p>
                                <div className="summary-card">
                                    <div className="summary-row"><span className="summary-key">Package</span><span className="summary-val highlightt">🥘 {productDetail?.product_name}</span></div>
                                    <div className="summary-row"><span className="summary-key">No of People</span><span className="summary-val">{contactInputs.contact_people}</span></div>
                                    <div className="summary-row"><span className="summary-key">Event Date</span><span className="summary-val">{moment(contextValues.selectedCateringMenu?.activeDay).tz(timeZone).format('dddd, DD MMM YYYY')}</span></div>
                                </div>
                            </div>
                            <div className="menu-chooser">
                                <div className="menu-chooser-header">
                                    <div className="menu-chooser-title">
                                        <span>🥘</span>
                                        <span>Budget Large · Scaled Daily Menu</span>
                                    </div>
                                </div>
                                <div>
                                    {TiffinItem?.length > 0 &&
                                        TiffinItem.map((items, categoryIndex) => {

                                            const selectedItems = items?.menu_items?.filter(
                                                (item) => (item.checked || Number(items.pti_moq) === 0) && items?.tiffin_category?.addon_category === 0
                                            );

                                            if (selectedItems.length === 0) return null;

                                            return (
                                                <div key={categoryIndex}>
                                                    <div className="menu-cat-label">
                                                        {items?.tiffin_category?.cat_name}
                                                    </div>

                                                    {selectedItems.map((item, index) => (
                                                        <div
                                                            key={index}
                                                            className="menu-dish-row chosen"
                                                        >
                                                            <div className="menu-dish-info">
                                                                <div className="menu-dish-name">
                                                                    {item.product_name}
                                                                </div>

                                                                <div className="menu-dish-desc">
                                                                    {item?.product_measure &&
                                                                        item?.product_measure !== "Select Measure" &&
                                                                        item?.product_unit_of_measure && (
                                                                            <span>
                                                                                {" "}
                                                                                QTY: {item.product_measure}{" "}
                                                                                {item.product_unit_of_measure} x{" "}
                                                                                {contactInputs.contact_people} {"Guests"} ={" "}
                                                                                {Number(item.product_measure) *
                                                                                    Number(contactInputs.contact_people)}{" "}
                                                                                {item.product_unit_of_measure}
                                                                            </span>
                                                                        )}
                                                                </div>
                                                                {item?.product_description && (
                                                                    <div className="menu-dish-desc">
                                                                        {item?.product_description}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            <div className="menu-dish-checkbox">
                                                                ✓
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                            {TiffinItem?.length > 0 &&
                                TiffinItem.map((items, categoryIndex) => {
                                    const selectedItems = items?.menu_items?.filter(item => item.qty > 0) || [];
                                    const selectedItemsTotal = selectedItems.reduce(
                                        (total, item) =>
                                            total + (Number(item.product_price || 0) * Number(item.qty || 0)),
                                        0
                                    );
                                    if (selectedItems.length === 0) {
                                        return null;
                                    }
                                    return (
                                        items?.tiffin_category?.addon_category !== 0 &&
                                        <div key={categoryIndex}>
                                            <div className="sum-menu-header">
                                                <span>✨ {items?.tiffin_category?.cat_name}</span>
                                                <span className="sum-menu-count">+${selectedItemsTotal}</span>
                                            </div>
                                            <div className="sum-dish-list">
                                                {items?.menu_items?.map((itemsChild, indexchild) => {
                                                    console.log("itemsChild", itemsChild);
                                                    if (itemsChild?.qty && itemsChild?.qty > 0) {
                                                        return (
                                                            <div className="sum-dish-row">
                                                                <div className="sum-dish-info">
                                                                    <div className="sum-dish-name">{itemsChild?.product_name}</div>
                                                                    <div className="sum-dish-desc">
                                                                        {itemsChild?.product_measure &&
                                                                            itemsChild?.product_measure !== "Select Measure" &&
                                                                            itemsChild?.product_unit_of_measure && (
                                                                                <span>
                                                                                    QTY: {itemsChild.product_measure} {itemsChild.product_unit_of_measure}{" "}
                                                                                    {Number(itemsChild?.qty) > 0 &&
                                                                                        <>
                                                                                            x{" "}
                                                                                            {itemsChild?.qty} ={" "}
                                                                                            {Number(itemsChild.product_measure) *
                                                                                                Number(itemsChild?.qty)}{" "}
                                                                                            {itemsChild.product_unit_of_measure}
                                                                                        </>
                                                                                    }

                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                    {itemsChild?.product_description && (<div className="sum-dish-desc">{itemsChild?.product_description}</div>)}
                                                                </div>
                                                                <div>${(Number(itemsChild?.product_price) * Number(itemsChild?.qty || 0)).toFixed(2)}</div>
                                                            </div>
                                                        )
                                                    }
                                                }
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            <div className="cart-totals">
                                <div className="cart-line">
                                    <span className="cart-line-label bold">{productDetail?.product_name}</span>
                                    <span className="cart-line-val">${Number(cartSummary?.sellingTotal).toFixed(2)}</span>
                                </div>

                                <div className="cart-line">
                                    <span className="cart-line-label bold">✨ Add-ons</span>
                                    <span className="cart-line-val">${Number(cartSummary?.addon_amount).toFixed(2)}</span>
                                </div>
                                <div className="cart-total-row">
                                    <div>
                                        <div className="cart-total-label">Total Due</div>
                                    </div>
                                    <div className="cart-total-amount">${Number(cartSummary?.total_amount).toFixed(2)}</div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="modal-back" aria-label="Go back" onClick={() => setCurrentStep(prev => prev - 1)}><i className="ri-arrow-left-line"></i></button>
                            <button className="modal-next" onClick={() => ContactformHandleStep3()} disabled={Loader}>
                                {Loader ? (
                                    <img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" />
                                ) : (
                                    <>Continue →</>
                                )}
                            </button>
                        </div>
                    </>
                }
                {currentStep === 4 && (
                    <>
                        <div className="modal-body">
                            <div className="modal-step active">
                                <p className="modal-intro">Enter your payment details to confirm the booking.</p>
                                <div className="pay-total-strip">
                                    <div className="pay-total-left">
                                        <div className="pay-total-label">Total Due (incl. GST)</div>
                                        <div className="pay-total-amount">${Number(cartSummary?.total_amount).toFixed(2) || 0}</div>
                                    </div>
                                    <div className="pay-total-badges">
                                        <span className="pay-badge">🔒 Secure</span>
                                        <span className="pay-badge">💳 Card</span>
                                    </div>
                                </div>
                                <div className="cart-totals">
                                    <div className="cart-line">
                                        <span className="cart-line-label bold">{productDetail?.product_name}</span>
                                        <span className="cart-line-val">${Number(cartSummary?.sellingTotal).toFixed(2)}</span>
                                    </div>
                                    <div className="cart-line">
                                        <span className="cart-line-label bold">Delivery Charge</span>
                                        <span className="cart-line-val">${Number(cartSummary?.delivery_amount).toFixed(2)}</span>
                                    </div>
                                    <div className="cart-line">
                                        <span className="cart-line-label bold">✨ Add-ons</span>
                                        <span className="cart-line-val">${Number(cartSummary?.addon_amount).toFixed(2)}</span>
                                    </div>
                                    <div className="cart-total-row">
                                        <div>
                                            <div className="cart-total-label">Total Due</div>
                                        </div>
                                        <div className="cart-total-amount">${Number(cartSummary?.total_amount).toFixed(2)}</div>
                                    </div>
                                </div>
                                <div className="pay-method-label">How would you like to receive your order?</div>
                                <div className="fulfil-tabs">
                                    <button className={`fulfil-tab ${contactInputs.contact_booking_type === 'delivery' ? 'active' : ''}`} onClick={() => { setcontactInputs(prev => ({ ...prev, ['contact_booking_type']: 'delivery' })); }}>
                                        <span className="fulfil-icon">🚚</span>
                                        <span className="fulfil-text">
                                            <span className="fulfil-name">Delivery</span>
                                            <span className="fulfil-sub">To your event address</span>
                                        </span>
                                    </button>
                                    <button className={`fulfil-tab ${contactInputs.contact_booking_type === 'pickup' ? 'active' : ''}`} onClick={() => { setcontactInputs(prev => ({ ...prev, ['contact_booking_type']: 'pickup' })); }}>
                                        <span className="fulfil-icon">🏪</span>
                                        <span className="fulfil-text">
                                            <span className="fulfil-name">Pickup</span>
                                            <span className="fulfil-sub">Collect from our store</span>
                                        </span>
                                    </button>
                                </div>
                                {contactInputs.contact_booking_type === 'delivery' && (
                                    <>
                                        <div class="alert alert-warning" role="alert">
                                            Standard delivery fee: ${Number(deliveryAmount)} (within 10km of store). Deliveries outside this radius are subject to additional charges, which will be quoted upon confirmation of your order.
                                        </div>
                                        <div className="fulfil-panel">
                                            <div className="field">
                                                <label for="f-address">Delivery Time <span>*</span></label>
                                                <input type="time" placeholder="Delivery time" name="contact_call_time" value={contactInputs.contact_call_time} onChange={handleContactInput} />
                                            </div>
                                        </div>
                                        <div className="fulfil-panel">
                                            <div className="field">
                                                <label for="f-address">Delivery Address <span>*</span></label>
                                                <input type="text" placeholder="Street address, suburb, postcode" name="contact_delivery_address" value={contactInputs.contact_delivery_address} onChange={handleContactInput} />
                                            </div>
                                        </div>
                                    </>
                                )}

                                {contactInputs.contact_booking_type === 'pickup' && (
                                    <>
                                        <div className="fulfil-panel">
                                            <div className="field">
                                                <label for="f-address">Pickup Time <span>*</span></label>
                                                <input type="time" placeholder="Pickup time" name="contact_call_time" value={contactInputs.contact_call_time} onChange={handleContactInput} />
                                            </div>
                                        </div>
                                        <div className="fulfil-panel">
                                            <div className="field">
                                                <label>Choose Pickup Store <span>*</span></label>
                                                <div className="store-grid">
                                                    {cateringBookingStores.map((store) => (
                                                        <label className="store-option">
                                                            <input type="radio" name="store" value={store.store_id} checked={contactInputs.contact_store_location === store.store_id} onClick={() => { setcontactInputs(prev => ({ ...prev, ['contact_store_location']: store.store_id })); }} />
                                                            <div className="store-card">
                                                                <div className="store-card-top">
                                                                    <span className="store-icon">📍</span>
                                                                    <span className="store-tick">✓</span>
                                                                </div>
                                                                <div className="store-name">{store.store_name}</div>
                                                                <div className="store-addr">{store.store_address}</div>
                                                                <div className="store-hours">Mon–Sat · {moment(store?.store_open_time, "HH:mm:ss").format("h:mm A") + '-' + moment(store?.store_close_time, "HH:mm:ss").format("h:mm A")}</div>
                                                            </div>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <div className="pay-method-label">Pay with</div>
                                <div className="pay-method-tabs">
                                    <button className={`pay-method-tab ${paymentMode === 'applepay' && 'active'}`} onClick={() => selectPayMethod('applepay')}>
                                        <div className="pay-tab-icon pay-tab-icon--apple">
                                            <svg viewBox="0 0 24 24" fill="white" width="20" height="20"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.41c1.39.07 2.33.74 3.13.8 1.18-.24 2.32-.93 3.57-.84 1.5.12 2.63.72 3.37 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.55 3.98zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"></path></svg>
                                        </div>
                                        <span>Apple Pay</span>
                                    </button>
                                    <button className={`pay-method-tab ${paymentMode === 'card' && 'active'}`} onClick={() => selectPayMethod('card')}>
                                        <div className="pay-tab-icon pay-tab-icon--card">
                                            <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" width="20" height="20"><rect x="2" y="5" width="20" height="14" rx="2"></rect><line x1="2" y1="10" x2="22" y2="10"></line><line x1="6" y1="15" x2="9" y2="15"></line><line x1="12" y1="15" x2="15" y2="15"></line></svg>
                                        </div>
                                        <span>Card</span>
                                    </button>
                                </div>
                                {paymentMode === 'applepay' &&
                                    <>
                                        <div className="pay-panel">
                                            <div className="wallet-info-card wallet-info-card--apple">
                                                <div className="wic-left">
                                                    <div className="wic-icon wic-icon--apple">
                                                        <svg viewBox="0 0 24 24" fill="white" width="26" height="26"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.41c1.39.07 2.33.74 3.13.8 1.18-.24 2.32-.93 3.57-.84 1.5.12 2.63.72 3.37 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.55 3.98zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"></path></svg>
                                                    </div>
                                                    <div>
                                                        <div className="wic-title">Apple Pay</div>
                                                        <div className="wic-sub">Face ID · Touch ID · Passcode</div>
                                                    </div>
                                                </div>
                                                <div className="wic-badge">Instant</div>
                                            </div>
                                            <div className="wallet-steps">
                                                <div className="ws-item"><span className="ws-num">1</span><span>Tap the button below</span></div>
                                                <div className="ws-item"><span className="ws-num">2</span><span>Authenticate with Face ID or Touch ID</span></div>
                                                <div className="ws-item"><span className="ws-num">3</span><span>Payment confirmed instantly</span></div>
                                            </div>
                                            {isOrderStop ? (<div className="alert alert-warning text-center mb-0 " role="alert" style={{ whiteSpace: 'pre-line' }}>{contextValues?.settingData?.order_stop_message || 'We are not accepting orders at the moment.'}</div>) : (
                                            <button className="apple-pay-btn" onclick="handleWalletPay('Apple Pay')">
                                                <svg viewBox="0 0 24 24" fill="white" width="22" height="22"><path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.7 9.05 7.41c1.39.07 2.33.74 3.13.8 1.18-.24 2.32-.93 3.57-.84 1.5.12 2.63.72 3.37 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.39-1.32 2.76-2.55 3.98zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"></path></svg>
                                                Pay with Apple Pay
                                            </button>
                                            )}
                                        </div>
                                        <div className="pay-secure-note">
                                            <span>🔐</span>
                                            <span>Your card details are never shared with Daadi's Kitchen</span>
                                        </div>
                                    </>}
                                {paymentMode === 'card' &&
                                    <>
                                        <div className="pay-panel">
                                            <div className="card-fields">
                                                <div className="field">
                                                    <label for="f-cardnum">Card Number <span>*</span></label>
                                                    <div className="card-input-wrap">
                                                        <input
                                                            type="text"
                                                            placeholder="0000  0000  0000  0000"
                                                            maxlength="19"
                                                            value={newCardState.number}
                                                            onChange={(e) => handleInputChange(e)}
                                                            name="number"
                                                        />
                                                        <span className="card-input-icon">💳</span>
                                                    </div>
                                                </div>
                                                <div className="field-row">
                                                    <div className="field">
                                                        <label>Expiry <span>*</span></label>
                                                        <input type="text"
                                                            name="expiry"
                                                            placeholder="MM / YY"
                                                            pattern="\d\d/\d\d"
                                                            value={newCardState.expiry}
                                                            onChange={(e) => handleInputChange(e)}
                                                        ></input>
                                                    </div>
                                                    <div className="field">
                                                        <label>CVV <span>*</span></label>
                                                        <div className="card-input-wrap">
                                                            <input type="text"
                                                                name="cvc"
                                                                placeholder="•••"
                                                                pattern="\d{3,4}"
                                                                value={newCardState.cvc}
                                                                onChange={(e) => handleInputChange(e)}
                                                                maxlength="4"
                                                            ></input>
                                                            <span className="card-input-icon">🔒</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="pay-secure-note">
                                            <span>🔐</span>
                                            <span>Your payment is encrypted and secure. We never store your card details.</span>
                                        </div>
                                    </>
                                }

                                <textarea
                                    style={{
                                        border: "1px solid #e3e7ed",
                                        borderRadius: "5px",
                                        height: "100px",
                                        width: "100%",
                                        marginTop: "1rem",
                                        padding: "0.75rem",
                                        fontSize: "0.9rem",
                                    }}
                                    name="contact_add_note"
                                    placeholder="Add a note for your booking (e.g. dietary requirements, delivery instructions)"
                                    value={contactInputs.contact_add_note}
                                    onChange={handleContactInput}
                                ></textarea>
                            </div>
                        </div>
                        {paymentMode === 'card' &&
                            <div className="modal-footer">
                                {!isOrderStop && <button className="modal-back" aria-label="Go back" onClick={() => setCurrentStep(prev => prev - 1)}><i className="ri-arrow-left-line"></i></button>}
                                {isOrderStop ? (<div className="alert alert-warning text-center mb-0 flex-grow-1" role="alert" style={{ whiteSpace: 'pre-line' }}>{contextValues?.settingData?.order_stop_message || 'We are not accepting orders at the moment.'}</div>) : (
                                <button className="modal-next" onClick={() => ContactformHandleStep4()} disabled={Loader}>
                                    {Loader ? (
                                        <img loading="lazy" src="/img/loder01.gif" alt="Loading..." width="90" height="15" />
                                    ) : (<>💳 Pay by Card </>
                                    )}
                                </button>
                                )}
                            </div>
                        }
                    </>
                )}

                {currentStep === 5 && (
                    <>
                        <div className="modal-success">
                            <div className="success-circle">🎉</div>
                            <div className="success-title">Booking Confirmed!</div>
                            <p className="success-sub">Payment received. We'll confirm your catering order within a few hours via call or WhatsApp.</p>
                            <div className="mt-4 pt-2 border-top">
                                <p className="fw-bold mb-2">If you want your event invite to feel a bit extra cute, you can make one for free on your iPhone with the Apple Invitations app. Click below to download the app.</p>
                                <a
                                    href="https://apps.apple.com/us/app/apple-invites/id6472498645"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-dark"
                                >
                                    <i className="ri-external-link-fill me-2"></i> Create an Event
                                </a>
                            </div>
                        </div>

                    </>
                )}
                {currentStep === 6 && (
                    <>
                        <div className="modal-success">
                            <div className="success-circle">🎉</div>
                            <div className="success-title">Thank you!</div>
                            <p className="success-sub">Your complete catering enquiry has been submitted.</p>
                            <p>We have received your details and will contact you shortly to confirm and discuss the next steps.</p>
                            <div className="mt-4 pt-2 border-top">
                                <p className="fw-bold mb-2">If you want your event invite to feel a bit extra cute, you can make one for free on your iPhone with the Apple Invitations app. Click below to download the app.</p>
                                <a
                                    href="https://apps.apple.com/us/app/apple-invites/id6472498645"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-dark"
                                >
                                    <i className="ri-external-link-fill me-2"></i> Create an Event
                                </a>
                            </div>
                        </div>

                    </>

                )}
            </Modal>
        </>
    );
}

export default CateringBookingModal;